module.exports = __webpack_public_path__ + "img/DE02606.a6dbd946.png";